"use client";
import { Container } from "@mui/material";
import QuestMenuBar from "./QuestMenuBar";

type Props = {
  children: React.ReactNode;
};

export default function QuestLayout({ children }: Props) {
  const introMode = false;

  return (
    <>
      <QuestMenuBar />
      <Container maxWidth={introMode ? "sm" : undefined} sx={{ mt: 2 }}>
        {children}
      </Container>
    </>
  );
}
